import type { FC } from "react"
import Box from "@mui/material/Box"

interface SeverityDotProps {
  color: string
  size?: number
}

/**
 * The frequency color as a dot, so every place that prints a per-span count —
 * map card, ribbon readout, span popup — shows severity the same way.
 */
const SeverityDot: FC<SeverityDotProps> = ({ color, size = 8 }) => (
  <Box
    component="span"
    aria-hidden
    sx={{
      display: "inline-block",
      flexShrink: 0,
      width: size,
      height: size,
      borderRadius: "50%",
      bgcolor: color,
      // Keeps the palest end of the ramp visible on any background.
      boxShadow: "0 0 0 1px rgba(0,0,0,0.35)",
    }}
  />
)

export default SeverityDot
